// Allowed over-collection percent (product CollectDeviation) → multiplier for the
// "gave more" threshold. 0 / undefined → factor 1 (feature off, behavior unchanged).
export const getOverweightFactor = (percent?: number): number =>
    percent ? 1 + percent / 100 : 1
